module.exports = __webpack_public_path__ + "static/media/shirts.573c384d.jpg";